import newRequest from '@/utils/new-request';

// 文件导出列表分页
export const apiFaFinancialExportExcelLogPage = (data, boolean = true) => {
  return newRequest({
    method: 'POST',
    url: '/excelTask/page',
    data,
    isLoading: boolean
  });
};

// 取消导出
export const apiFaFinancialExportExcelCancel = id => {
  return newRequest({
    method: 'POST',
    url: `/excelTask/cancel?id=${id}`,
    isLoading: true
  });
};
